var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"child"},[_c('h2',{staticClass:"child-title"},[_vm._v("Child")]),_c('button',{on:{"click":_vm.handleClick}},[_vm._v("Click me!")])])}
var staticRenderFns = []

export { render, staticRenderFns }